export default "Z,Øst-Finnmark\nY,Vest-Finnmark\nX,Troms\nW,Nordland\nV,Nord-Trøndelag\nU,Sør-Trøndelag og Hedmark\nØ,Tamreinlag\nR,Rendalen"